export default "__VITE_ASSET__vdcx9MD3__"